module.exports = __webpack_public_path__ + "static/media/RA-KV0404B_01.4fecc06e.png";